import type {EventAttachmentFilter} from 'src/types/report';

import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {FilterCard} from './';
import RadioButtons from 'src/components/lib/radio-buttons';

import css from './survey-chatbot-card.css';
import {type TranslationFunction} from 'src/types/language-support';


type Props = {
  onSave?: (e: React.SyntheticEvent) => unknown;
  onCancel?: (e: React.SyntheticEvent) => unknown;
  onTypeChange: (e: React.SyntheticEvent) => unknown;
  selectedType?: string;
};

const getFilterTypes = (t: TranslationFunction) => [
  {
    value: null,
    label: t('All_metrics', 'All metrics'),
  },
  {
    value: 'survey_only',
    label: t('Surveys_only', 'Surveys only'),
  },
  {
    value: 'chatbot_only',
    label: t('Chatbots_only', 'Chatbots only'),
  },
];

const SurveyAndChatbotCard = ({
  onSave,
  onCancel,
  onTypeChange,
  // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'string'.
  selectedType = null,
}: Props) => {
  const {t} = useLabelTranslation();
  const filterTypes = getFilterTypes(t);
  return (
    <FilterCard
      header={t('Surveys_chatbots', 'Surveys & chatbots')}
      onSave={onSave}
      onCancel={onCancel}
    >
      <div className={css.filterContent}>
        <RadioButtons
          // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'SyntheticEvent<Element, Event>'.
          selectedValue={selectedType}
          onChange={onTypeChange}
          // @ts-expect-error - TS2322 - Type '({ value: null; label: any; } | { value: string; label: any; })[]' is not assignable to type '{ value: SyntheticEvent<Element, Event>; label: string; }[]'.
          options={filterTypes}
          labelClassName={css.radioDisplay}
          bodyClassName={css.flexColumn}
        />
      </div>
    </FilterCard>
  );
};

export default SurveyAndChatbotCard;
